import React from 'react';
import {Button} from '@mui/material';
import {COLORS} from '@fupa/fupa-uikit';
import {sendEventToGA4} from 'app/helpers/gtagHelpers';
import {useSoftTickerContext} from 'app/hooks/useSoftTickerContext';
import {openAddScorer} from 'app/actions/softTickerActions';

interface AddScorerButtonProps {
  match: any;
}

export default function AddScorerButton({match}: AddScorerButtonProps) {
  const {dispatch} = useSoftTickerContext();
  const handleClick = () => {
    sendEventToGA4('soft_ticker_report_scorer', {
      soft_ticker_action: 'open',
      ui_view: 'page_match_index',
      match_slug: match.slug,
    });
    dispatch(openAddScorer('layer_add_scorer'));
  };

  return (
    <Button variant='text' sx={{color: COLORS.darkerGrey}} onClick={handleClick}>
      + Torschütze hinzufügen
    </Button>
  );
}
